export default "__VITE_ASSET__a4d3eafc__"